export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validatePhoneNumber = (phoneNumber) => {
    //validates only nigerian phone numbers
    const phoneRegex = /^(?:(\+234)|(234)|0)([7-9])(\d{9})$/;
    return phoneRegex.test(phoneNumber);
};